<template>
  <main class="AuthLoginView">
    <div class="container">
      <div class="AuthLoginView__card">
        <header>
          <img src="/img/capital-flow-tech-logo.svg" alt="Capital Flow Tech" class="AuthLoginView__logo">
          <span class="AuthLoginView__divider"></span>
          <h1 class="AuthLoginView__title">Client Platform</h1>
          <p class="AuthLoginView__subtitle">Sign in to your Capital Flow Tech account. Access account statements and software deployment information.</p>
        </header>

        <div class="alert alert-danger" v-if="message">
          {{ message }}
        </div>

        <form novalidate @submit.prevent="onSubmit" class="form">
        <div class="mb-3">
          <FormInput label="Email" name="email" :validator="v$.form.email" autocomplete="username" />
        </div>

        <div class="mb-3">
          <FormPassword label="Password" name="password" autocomplete="current-password" :validator="v$.form.password" />
        </div>

        <div class="mb-3 d-flex justify-content-between">
          <div>
            <FormSwitch v-model="form.remember" text="Remember me" />
          </div>
          <!--
            <div>
            <router-link class="text-secondary" :to="{ name: 'auth-reset-email' }">
              Forgot password?
            </router-link>
          </div>
          -->
        </div>

        <div class="AuthLoginView__button">
          <button class="btn btn-primary" :disabled="v$.form.$invalid">
            Sign in
          </button>
        </div>

        <!-- <ModalPasswordForm /> -->

        <!--
        <router-link class="text-secondary" :to="{ name: 'auth-register' }">
          Don't have an account yet?
        </router-link>
        -->
        </form>
      </div>

      <p class="AuthLoginView__legal">
        Capital Flow Tech provides software infrastructure and <span class="nowrap">API-based</span> algorithmic trading technology for <span class="nowrap">digital-asset</span> markets. CFT does not provide investment advice, asset management, portfolio management, brokerage, custody, <span class="nowrap">deposit-taking</span> or discretionary financial services.
      </p>
    </div>
  </main>
</template>

<script>
  import FormInput from '@/components/base/FormInput'
  import FormPassword from '@/components/base/FormPassword'
  import FormSwitch from '@/components/base/FormSwitch'

  import ModalPasswordForm from '@/components/ModalPasswordForm'

  import useModal from '@/plugins/modal/useModal'
  import useVuelidate from '@vuelidate/core'
  import { required } from '@vuelidate/validators'
  import { mapState, mapActions } from 'vuex'

  export default {
    components: {
      FormInput,
      FormPassword,
      FormSwitch
    },

    setup() {
      return {
        v$: useVuelidate(),
        modal$: useModal()
      }
    },

    data() {
      return {
        message: '',
        form: {
          email: '',
          password: '',
          remember: false
        }
      }
    },

    validations() {
      return {
        form: {
          email: { required },
          password: { required }
        }
      }
    },

    computed: {
      ...mapState('auth', [ 'authenticated' ])
    },

    methods: {
      ...mapActions('auth', [ 'login' ]),

      onSubmit() {
        this.v$.form.$touch()

        this.login({
          email: this.form.email,
          password: this.form.password,
          remember: this.form.remember
        }
        ).then((response) => {
          if (response.otp) {
            this.modal$
              .open(ModalPasswordForm, {
                size: 'md',
                closeOnBackdrop: false,
                closeOnEsc: false,
                props: {
                  password: this.form.password,
                  authenticated: response
                }
              })
              .onClose(() => {
                this.$router.push({ name: 'dashboard' })
              })
          } else if (response.admin) {
            this.$router.push({ name: 'clients' })
          } else {
            this.$router.push({ name: 'dashboard' })
          }
        }).catch((error) => {
          this.message = error.data.message
        })
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import '@/sass/styles.vars.all.sass'

  .AuthLoginView > .container
    max-width: 430px

  .AuthLoginView__card
    background: #fffdf9
    border: 1px solid rgba(#14264f, .08)
    border-radius: 16px
    box-shadow: 0 18px 44px rgba(#14264f, .10), 0 2px 8px rgba(#14264f, .04)
    padding: $spacer-5

    header
      text-align: center
      margin-bottom: $spacer-4

  .AuthLoginView__logo
    width: 104px
    height: auto
    display: block
    margin: 0 auto $spacer-2

  .AuthLoginView__divider
    display: block
    width: 44px
    height: 2px
    margin: 0 auto $spacer-3
    background: #c2a15f
    border-radius: 2px

  .AuthLoginView__title
    color: #14264f
    text-transform: uppercase
    font-size: 1.3em
    font-weight: 600
    letter-spacing: .05em
    margin-bottom: .5em

  .AuthLoginView__subtitle
    color: rgba(#14264f, .62)
    line-height: 1.5
    margin-bottom: 0

  .AuthLoginView__button
    margin-top: $spacer-4

    :deep(.btn-primary)
      width: 100%
      padding-top: .6rem
      padding-bottom: .6rem
      background-color: #14264f
      border-color: #14264f
      color: white
      font-weight: 500
      letter-spacing: .02em

      &:hover, &:focus, &:active
        background-color: #0d1b3b
        border-color: #0d1b3b

      &:disabled
        background-color: #d3d7e0
        border-color: #d3d7e0
        color: white
        opacity: 1

  .AuthLoginView__legal
    margin: $spacer-4 auto 0
    padding: 0 $spacer-2
    max-width: 400px
    text-align: center
    font-size: .76rem
    line-height: 1.6
    color: rgba(#14264f, .48)
    overflow-wrap: break-word

    .nowrap
      white-space: nowrap
</style>
